'use client';

import { ButtonVariants } from '@pixum/button';
import { useCheckoutOrder } from '../../hooks/checkout';
import { ProceedButton } from '../../partials/ProceedButtonStream/ProceedButton';
import type { CheckoutOrderButtonProps } from '../types';

export function CheckoutOrderButton({ isDataPrivacyRequired, children }: CheckoutOrderButtonProps) {
  const { isBusy, handleOrderClick } = useCheckoutOrder({ isDataPrivacyRequired });

  return (
    <ProceedButton variant={ButtonVariants.STRONG} isBusy={isBusy} isClickable={!isBusy} onClick={handleOrderClick}>
      {children}
    </ProceedButton>
  );
}
